import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBook,
  faHome,
  faInfoCircle,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import "./landingNavbarAteditor.css";

const Navbar = ({
  showDocumentation,
  setShowDocumentation,
  setShowCode,
  setShowPreview,
  LayOut,
}) => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
  };

  const ClassForLandingNav =
    LayOut === 1 || LayOut === 2 || LayOut === 3
      ? "NavbarAtEditorOne"
      : "NavbarAtEditor";

  return (
    <React.Fragment>
      <nav className={ClassForLandingNav}>
        <a style={{color:"#000000"}} className="NavbarButton" href="/">
          <FontAwesomeIcon icon={faHome} />
          <span className="labelForIcons">Home</span>
        </a>
        <button
          className="NavbarButton"
          onClick={() => {
            setShowDocumentation(!showDocumentation);
            setShowCode(false);
            setShowPreview(false);
          }}
        >
          <FontAwesomeIcon icon={faBook} />
          <span className="labelForIcons">Documentation</span>
        </button>
        <button
          className="NavbarButton"
          onClick={() => handleNavigation("/about")}
        >
          <FontAwesomeIcon icon={faInfoCircle} />
          <span className="labelForIcons">About</span>
        </button>
        <button
          className="NavbarButton"
          onClick={() => handleNavigation("/profile")}
        >
          <FontAwesomeIcon icon={faUser} />
          <span className="labelForIcons">Profile</span>
        </button>
      </nav>
    </React.Fragment>
  );
};

export default Navbar;
